RivalIQ.apps.Analyze.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.GraphModal = Marionette.LayoutView.mixin({
        template: '#analyzeGraphModalTemplate',
        ui: {
            modal: '.x-analyze-graph-modal',
            graph: '.x-analyze-graph-modal-graph'
        },
        regions: {
            graph: '.x-analyze-graph-modal-graph'
        },
        mixins: {
            props: Marionette.Dashboard.mixins.Props,
            modalBackdropResizing: RivalIQ.apps.Shell.views.ModalBackdropResizing
        },
        graphLineHeight: 28,
        graphMinimumHeight: 300,

        // ModalBackdropResizing Overrides
        getModal: function () {
            const me = this;
            return me.ui.modal;
        },

        getModalBodyClientHeight: function () {
            const me = this;
            return _.head(me.$('.x-analyze-graph-modal-graph')).clientHeight;
        },

        templateHelpers: function () {
            const me = this;

            return {
                subtitle: RivalIQ.utils.timePeriod.getTimePeriodDisplayString(me.getProp('timePeriod'))
            };
        },
        serializeData: function () {
            const me = this;

            return {
                title: RivalIQ.metric.names.metricName(me.getProp('metrics')[0], {
                    dimensions: ['channel']
                })
            };
        },
        onAttach: function () {
            const me = this;

            me.ui.modal.on('shown.bs.modal', renderGraph);

            me.ui.modal.modal({
                keyboard: true
            });

            function renderGraph() {
                me.ui.modal.off('shown.bs.modal');

                const view = new RivalIQ.apps.Dashboard.widgets.MetricBar({
                    dashboardModel: me.dashboardModel
                });

                // the default getHeight takes the window size into account
                // which is problematic in the modal, as it can cause the initial
                // modal render to need vertical scrolling when it shouldn't
                view.getHeight = function (data) {

                    const height = data.length * me.graphLineHeight;
                    return height < me.graphMinimumHeight ? me.graphMinimumHeight : height;
                };

                // the render order matters here because we need the parent width
                view.width = me.ui.graph.width();

                // don't render the chart yet, if we add the element before rendering
                // then the table chart column widths will be correct
                me.ui.graph.html(view.$el);

                // since we already added the element this will just spew out the
                // chart, and correctly to boot
                me.graph.show(view);
            }
        }
    });
});
